/* HARMONY — Rodapé
   Portado do protótipo (harmony-prototype.html, "NAVEGAÇÃO DO RODAPÉ").
   O roteamento SPA original (data-nav/data-legal) virou <a href> normal —
   aqui sobra só o efeito de destaque ao clicar em "Formas de pagamento". */
(function () {
  function initFooterPayments(root) {
    var btn = root.querySelector('[data-scroll-to]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var target = root.querySelector(btn.getAttribute('data-scroll-to'));
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.style.transition = 'opacity .3s';
      target.style.opacity = '.35';
      setTimeout(function () {
        target.style.opacity = '1';
      }, 320);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hmy-footer').forEach(initFooterPayments);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var footer = e.target.querySelector ? e.target.querySelector('.hmy-footer') : null;
    if (footer) initFooterPayments(footer);
  });
})();
